module.exports = __webpack_public_path__ + "media/images/panganight@3x_sp-4e970a133d6cf889d8fd583d2191d85a.png";